import TitleSmall from "./title-small.js";

export default TitleSmall;
